module.exports = __webpack_public_path__ + "static/img/group21.304cc44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group21.jpg
// module id = D3bW
// module chunks = 0